import { defineStore } from 'pinia'
import axios from 'axios'
import { usePage } from '@inertiajs/vue3'

const page = usePage()

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        panelOpen: page.props.state.notifications_panel_open,
        notifications: [],
    }),

    getters: {
        unreadNotifications: (state) => {
            return state.notifications.filter(n => !n.is_read)
        },

        unreadNotificationsCount: (state) => {
            return state.unreadNotifications.length
        },
    },

    actions: {
        async getNotifications () {
            axios.get(`/api/user/notifications`).then((response) => {
                this.notifications = response.data
            })
        },

        markNotificationRead (id) {
            axios.patch(`/api/user/notifications/${id}`).then((response) => {
                this.notifications.find(n => n.id === id).is_read = true
            })
        },

        markAllNotificationsRead () {
            axios.patch(`/api/user/notifications`).then((response) => {
                this.notifications = this.notifications.map((n) => {
                    if (!n.is_read) {
                        n.is_read = true
                    }

                    return n
                })
            })
        }
    }
})
